import { styleHookSingleton } from "./hook";
export var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles;
        useStyle(styles);
        return null;
    };
    return Sheet;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-style-singleton/dist/es2015/component.js
// module id = 525
// module chunks = 0